import { Grid, Paper } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import CustomButton from '../layout/customButton/CustomButton';
import SearchBox from '../searchBox/SearchBox';
import styles from './Leads.module.scss';
import LeadsTable from './LeadsTable';
import { connect } from 'react-redux';
import { getLeads } from '../../redux/deals/action';
import Spinner from '../layout/spinner/Spinner';
import Appointments from '../dashboard/appointments/Appointments';
import DealStatus from '../dashboard/dealStatus/DealStatus';
import { getVisibleClients } from '../../redux/clients/actions';

const Leads = ({ getLeads, leads, loading, user, getVisibleClients }) => {
	const [search, setSearch] = useState('');
	const [filterByDate, setFilterByDate] = useState('All');
	const [salesAgentId, setSalesAgentId] = useState('allSalesAgents');
	const [section, setSection] = useState('leads');
	const [filteredLead, setFilteredLead] = useState();

	useEffect(() => {
		getLeads();
		getVisibleClients();
	}, []);

	const handleChange = (e) => {
		setSearch(e.target.value);
	};

	useEffect(() => {
		console.log('sectionn0', section);
	}, [section]);

	const handleSection = (e) => {
		var data = e.currentTarget.dataset.section;

		console.log('data', data);

		if (data === 'leads') {
			setSection(data);
		} else if (data === 'purchases') {
			setSection(data);
		}
	};

	const handleAddLead = () => {};

	return (
		<div className={styles.leads}>
			{loading === true && (
				<div className={styles.loading}>
					<Spinner />
				</div>
			)}
			<div className={styles.header_group}>
				<h2 className={styles.title}>Deals</h2>
				<div className={styles.search_group}>
					<SearchBox
						placeholder='Search'
						handleChange={handleChange}
					/>
				</div>
			</div>

			<hr className={styles.divider} />

			<div className={styles.selector_group}>
				<div
					className={`${styles.selector_btn}  ${
						section === 'leads' && styles.active
					}`}
					data-section='leads'
					onClick={(e) => handleSection(e)}
				>
					Leads
				</div>
				<div
					className={`${styles.selector_btn} ${
						section === 'purchases' && styles.active
					}`}
					data-section='purchases'
					onClick={(e) => handleSection(e)}
				>
					Purchases
				</div>
			</div>

			<Grid container spacing={3}>
				<Grid item xs={9}>
					<Paper className={styles.leads_table}>
						<div className={styles.table_header_group}>
							<h2 className={styles.table_title}>
								Leads ({leads.length})
							</h2>

							<CustomButton
								onClick={handleAddLead}
								width={166}
								height={42}
							>
								Add Lead
							</CustomButton>
						</div>

						<LeadsTable leads={leads} search={search} />
					</Paper>
				</Grid>
				<Grid item xs={3}>
					<Grid item xs={12}>
						{user.userType === 'superadmin' ? (
							<Appointments
								salesAgentId={salesAgentId}
								filterByDate={filterByDate}
							/>
						) : (
							<Appointments filterByDate={filterByDate} />
						)}
					</Grid>

					<Grid item xs={12}>
						{user.userType === 'superadmin' ? (
							<DealStatus
								salesAgentId={salesAgentId}
								filterByDate={filterByDate}
							/>
						) : (
							<DealStatus
								salesAgentId={user.uid}
								filterByDate={filterByDate}
							/>
						)}
					</Grid>
				</Grid>
			</Grid>
		</div>
	);
};

const mapStateToProps = (state) => ({
	leads: state.leads.leads,
	loading: state.leads.loading,
	user: state.signIn,
});

export default connect(mapStateToProps, { getLeads, getVisibleClients })(Leads);
